import * as React from 'react';
import { FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { getLastAuthContext } from '../../shared/authContext';
import { paths } from '../../app/constants';

/**
 * Smart router for /login route
 * Redirects to /login/professional or /login/client based on saved context
 * If no context exists, shows the context chooser
 */
const LoginRouter: FC = () => {
    const location = useLocation();
    const lastContext = getLastAuthContext();

    // If user has a saved context, auto-redirect to the appropriate login page
    if (lastContext === 'professional') {
        return <Redirect to={paths.loginProfessional() + location.hash} />;
    }

    if (lastContext === 'client') {
        return <Redirect to={paths.loginClient() + location.hash} />;
    }

    // No saved context - redirect to chooser
    // We need to let the App handle routing to the chooser component
    return <Redirect to={paths.login() + '/chooser' + location.hash} />;
};

export default LoginRouter;
